// fixing skip to content links
( function( $ ) {
	
	// move focus on hashchange
	window.addEventListener( 'hashchange', function( /* event */ ) {

		let element = document.getElementById( location.hash.substring( 1 ));

		if ( element ) {

			if ( !/^(?:a|select|input|button|textarea)$/i.test( element.tagName ) ) {
				element.tabIndex = -1;
			}

			element.focus();
		}

	}, false); 
	
	// set hash main on skip-to-main click
	$( '.skip-to-main' ).on( 'click', function( event ) {
		event.preventDefault();
		document.location.hash = 'main';
	});
	
})($);